import React, { useContext, useState } from 'react';
import logo from '../../images/logo/logo1.jpg';
import './Navbar.css';
import DehazeIcon from '@material-ui/icons/Dehaze';
import { useMediaPredicate } from "react-media-hook";
import { Link } from 'react-router-dom';

const Navbar = () => {

    const smallerDevice = useMediaPredicate("(max-width: 990px)");
    const active = window.location.pathname;

    return (
        <nav className="navbar sticky-top navbar-expand-lg navbar-light custom-navbar">
            <Link className="navbar-brand" to="/"><img width="50px" src={logo} alt="" /></Link>

            {smallerDevice && <DehazeIcon className="toggle-button" id="nav-toggle-button"
                type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation"
            />}

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <Link className="text-decoration-none" to="/"><h5 className={`custom-nav-item mr-5 + ${active == '/' ? "nav-active" : ""}`}>Home</h5></Link>
                    </li>
                    <li className="nav-item">
                        <Link className="text-decoration-none" to="/about"><h5 className={`custom-nav-item mr-5 + ${active == '/about' ? "nav-active" : ""}`}>About Me</h5></Link>
                    </li>
                    <li className="nav-item">
                        <Link className="text-decoration-none" to="/portfolio"><h5 className={`custom-nav-item mr-5 + ${active == '/portfolio' ? "nav-active" : ""}`}>Portfolio</h5></Link>
                    </li>
                    <li className="nav-item">
                        <Link className="text-decoration-none" to="/blogs"><h5 className={`custom-nav-item mr-5 + ${active == '/blogs' ? "nav-active" : ""}`}>Blog</h5></Link>
                    </li>
                    <li className="nav-item">
                        <Link className="text-decoration-none" to="/contact"><h5 className={`custom-nav-item mr-5 + ${active == '/contact' ? "nav-active" : ""}`}>Contact</h5></Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;